var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "outer-carousel-wrapper", on: { click: _vm.close } },
        [
          _c(
            "div",
            {
              staticClass: "model-content",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.stopClick.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "top-content" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v("保险智能云全新版本来袭")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tip" }, [
                  _vm._v(
                    "V5-AI创收版全新上线，AI微信工作台，AI报价机器人，AI数字营销，AI增员激励，保险商城，车主服务。"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tip" }, [
                  _vm._v("六大能力助力企业营收增长利润翻倍。")
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "rocket-image",
                  attrs: {
                    src: require("../assets/images/outer/rocket.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-close close-icon",
                  on: { click: _vm.close }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-carousel",
                {
                  staticClass: "bottom-content",
                  attrs: { trigger: "click", autoplay: false }
                },
                _vm._l(_vm.list, function(item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    _c("div", { staticClass: "carousel-content" }, [
                      _c(
                        "div",
                        { staticClass: "left-content" },
                        _vm._l(item.list, function(ite, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "left-item",
                              class: {
                                active: _vm.form[item.name] === ite.icon
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.chooseTab(item.name, ite.icon)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "title-content" }, [
                                _c("img", {
                                  staticClass: "left-icon",
                                  attrs: {
                                    src: require("@/assets/images/outer/" +
                                      ite.icon +
                                      "-icon.png"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "left-title" }, [
                                  _vm._v(_vm._s(ite.title))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "left-detail" }, [
                                _vm._v(_vm._s(ite.content))
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "right-content",
                        class: _vm.form[item.name]
                      })
                    ])
                  ])
                }),
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-416d099b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-416d099b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/outerCarousel.vue
// module id = null
// module chunks = 